import PropTypes from 'prop-types';
import React from 'react';

import FilmCard from '../cards/Film';
import PageMeta from '../partials/PageMeta';

import styles from '../../../styles/pages/films.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function FilmsPage({ page = null }) {
    const { films = null } = page || {};
    return (
        <div className={styles.container}>
            <PageMeta page={page} />
            <div className={styles.grid}>
                {(films || []).map((film) => (
                    <FilmCard key={`film-${film?.id}`} item={film} />
                ))}
            </div>
        </div>
    );
}

FilmsPage.propTypes = propTypes;

export default FilmsPage;
